export const Index = () => import("../Components/Company/index.vue");
// export const DailyParadeState = () => import("../Components/Company/daily_parade_state");
export const CurrentParadeState = () => import("../Components/Company/parade_state_current.vue");
export const ParadeStateDate = () => import("../Components/Company/parade_state_date.vue");
export const ParadeHeld = () => import("../Components/Company/held_details.vue");

// export const CompanyPresent = () => import("../Components/Company/company_present");
export const AttCompanyPresent = () => import("../Components/Company/att_company_present.vue");
export const CompanyAbsent = () => import("../Components/Company/company_absent.vue");
export const ParadeStateAbsent = () => import("../Components/Company/parade_state_absent.vue");
export const CompanyAbsentDetails = () => import("../Components/Company/company_absent_details.vue");

export const ParadeState = () => import("../Components/ParadeState/List.vue");
export const ParadeStateDetails = () => import("../Components/ParadeState/Details.vue");
export const Dashboard = () => import("../Components/Dashboard.vue");
